// extracted by mini-css-extract-plugin
export default {"nestedItem":"SelectDuplicateFieldsModal_nestedItem__l4+jq"};